/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
/*global showAjaxError*/

window.corpSbBehaviour = window.corpSbBehaviour || {};
corpSbBehaviour.corpAuthAndWorkflow = {
    properties: {
        // fix for 312552, 312790, 312793,312789 issues
        previewDetails: {
            type: Object,
            notify: true,
            value: function () {
                var obj = {
                    followHierarchy: false,
                    ruleDefinition: "",
                    progressDetails: [],
                    isMultipleApprovalSelection: false,
                    hidePriority: false,
                    selectedApprovers: [],
                    approversPost: [],
                    authMethods: [],
                    approverComment: "",
                    displayAuthorization: false,
                    displayWorkflow: false,
                    displayComments: false,
                    isConfirmationMode: ""
                }
                return obj;
            }


        },
        selectedRule: {
            type: Object,
            notify: true

        }, channelObject: {
            type: Object,
            notify: true,
            value: {}
        }
    },
    // fix for 312552, 312790, 312793,312789 issues
    // method for reseting the PreviewDetails property 
    setDefaultPreviewDetails: function () {
        this.previewDetails.followHierarchy = false;
        this.previewDetails.ruleDefinition = "";
        this.previewDetails.progressDetails = [];
        this.previewDetails.isMultipleApprovalSelection = false;
        this.previewDetails.hidePriority = false;
        this.previewDetails.selectedApprovers = [];
        this.previewDetails.approversPost = [];
        this.previewDetails.approverComment = "";
        this.previewDetails.displayAuthorization = false;
        this.previewDetails.displayWorkflow = false;
        this.previewDetails.displayComments = false;
        this.previewDetails.authMethods = [];
        this.previewDetails.isConfirmationMode = ""
    },
    submitFinancialDetails: function (url, method, body, headervalue, transactionType, transactionAmount, transactionCurrency, channelContextVal, highestEntryAmount, isZeroAmountTransaction, debitAccountvalue) {
        //added debitAccountvalue argument for 273463 fix
        var self = this;
        this.fire('start-processing-loader');
        let ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = url;
        ajaxCall.method = method;
        ajaxCall.body = body;

        if (channelContextVal === undefined) {
            if (ajaxCall.header == undefined || Object.keys(ajaxCall.header).length == 0) {
                ajaxCall.headers["authorizationDetails"] = JSON.stringify({
                    primaryAccessCode: headervalue.primaryAccessCode ? headervalue.primaryAccessCode :
                        "",
                    secondaryAccessCode: headervalue.secondaryAccessCode ? headervalue.secondaryAccessCode :
                        "",
                    userId: clientStorage.get(storageType.session, 'userId'),
                    acceptTermsAndConditions: headervalue.acceptTermsAndConditions ? headervalue.acceptTermsAndConditions :
                        "",
                    isConfirmationMode: this.previewDetails.isConfirmationMode ? this.previewDetails.isConfirmationMode : "",
                    customParameters: {
                        ochTransactionId: headervalue.ochTransactionId ? headervalue.ochTransactionId : "",
                        authorizationMode: headervalue.authorizationMode ? headervalue.authorizationMode : ""
                    }
                    // fix for 312552, 312790, 312793,312789 issues
                });
            }

            if (headervalue.workflowInput) {
                var finalHeaders = JSON.parse(ajaxCall.headers["authorizationDetails"]);
                finalHeaders.workflowInput = headervalue.workflowInput ? headervalue.workflowInput : ""
                ajaxCall.headers["authorizationDetails"] = JSON.stringify(finalHeaders);
            }
        } else {
            ajaxCall.headers["authorizationDetails"] = "";
        }

        ajaxCall.addEventListener('response', function (event) {
            self.fire('stop-processing-loader');
            self.loaderActive = false;
            //Status Code 204 has been added for delete functionality
            if (event.detail.__data.status === 200 || event.detail.__data.status === 204) {
                self.previewDetails.successMessage = event.detail.__data.status;
                if (typeof self._callSucessPage == 'function')
                    _scrollIntoView();
                self._callSucessPage(event);
            }
        });
        ajaxCall.addEventListener('error', function (event) {
            self.fire('stop-processing-loader');
            self.loaderActive = false;
            if (event.detail.request.__data.status === 401) {
                var responseHeader = JSON.parse(event.detail.request.xhr.getResponseHeader(
                    'channelcontext'));

                self.channelContext = responseHeader;
                self.channelObject = self.channelContext;
                if (responseHeader.authorization != undefined) {
                    //Set confirmation mode
                    self.set('previewDetails.isConfirmationMode', responseHeader.authorization.isConfirmationMode);
                    this.header = {
                        "primaryAccessCode": responseHeader.authorization.firstAuthorizationMode,
                        "secondaryAccessCode": responseHeader.authorization.secondAuthorizationMode
                    }
                    self.headerObject = this.header;
                    if (responseHeader.authorization.firstAuthorizationMode || responseHeader.authorization.secondAuthorizationMode)
                        self.setAuthorizationModes(this.header);

                    if (responseHeader.authorization.workFlowRequired === 'Y') {
                        self.set('previewDetails.displayComments', false);
                        if (!transactionAmount && !transactionCurrency) {
                            if (typeof self._workFlowHandler == 'function')
                                self._workFlowHandler(event);
                        } else {
                            self.responseObjectWorkflow = event;
                            //NBB Hybrid specific code
                            if (['HV1', 'HV2', 'HV3', 'HS3', 'HS1', 'HS2'].includes(transactionType)) {
                                var hybridResponse = event.detail.request.__data.response.error.message[0];
                                if (hybridResponse.debitAccount) {
                                    if (hybridResponse.debitAccount.includes("AE") || hybridResponse.debitAccount.includes("BH")) {
                                        var tempAccount = hybridResponse.debitAccount.substring(hybridResponse.debitAccount.length - 10);
                                        if (tempAccount.length < 16) {
                                            while (tempAccount.length < 16) {
                                                tempAccount = "0" + tempAccount;
                                            }
                                        }
                                        debitAccountvalue = tempAccount;
                                    }
                                    else {
                                        debitAccountvalue = hybridResponse.debitAccount;
                                    }
                                }
                                //debitAccountvalue = hybridResponse.debitAccount;
                                transactionAmount = hybridResponse.homeCurrencyAmountVO ? hybridResponse.homeCurrencyAmountVO.amount : "";
                                transactionCurrency = hybridResponse.homeCurrencyAmountVO ? hybridResponse.homeCurrencyAmountVO.currency : "";
                                highestEntryAmount = hybridResponse.homeCurrencyAmountVO ? hybridResponse.homeCurrencyAmountVO.amount : "";
                            }
                            // changes made for 273463 fix
                            self.financialWorkflow(transactionType, transactionAmount, transactionCurrency, debitAccountvalue, highestEntryAmount, isZeroAmountTransaction);
                        }
                        if (responseHeader.authorization.firstAuthorizationMode)
                            self.set('previewDetails.displayAuthorization', true);
                    } else {
                        if (responseHeader.authorization.workFlowRequired === 'N') {
                            self.set('previewDetails.displayWorkflow', false);
                            self.set('previewDetails.displayComments', true);
                            self.set('previewDetails.approverComment', "");
                            self.set('previewDetails.ruleId', "");
                        }
                        self.set('previewDetails.displayAuthorization', true)
                        _scrollIntoView();
                        self._callWorkflowPage(event);
                    }
                } else {
                    if (typeof self._errorHandler == 'function')
                        self._errorHandler(event);
                    //self.fire('oe-show-error', event.detail.error.message);
                    showAjaxError(event);
                }
            } else {
                self.authSuccess = false;
                var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
                var headers = convertedArr.reduce(function (each, current) {
                    var parts = [current.split(": ", 1).toString(), current.split(": ").slice(
                        1).join(": ")];
                    each[parts[0]] = parts[1];
                    return each;
                }, {});
                if (headers.channelcontext) {
                    if (typeof self._errorHandler == 'function')
                        self._errorHandler(event);
                    else
                        self.fire('oe-show-error', JSON.parse(headers.channelcontext).status.message[
                            0]
                            .messageDesc);
                } else
                    self.fire('oe-show-error', event.detail.error.message);
            }
        });
        oeAjaxEventListner(ajaxCall);
        if (!headervalue || headervalue && _.isEmpty(headervalue.ochTransactionId)) {
            ajaxCall.generateRequest();
        }
        else if (headervalue && headervalue.ochTransactionId) {
            if (_.isEmpty(self.ochTxnIdSuccess)) {
                self.ochTxnIdSuccess = headervalue.ochTransactionId;
                ajaxCall.generateRequest();
            }
            else if (headervalue.ochTransactionId !== self.ochTxnIdSuccess) {
                self.ochTxnIdSuccess = headervalue.ochTransactionId;
                ajaxCall.generateRequest();
            }
            else {
                self.fire('stop-processing-loader');
            }
        }
    },

    setAuthorizationModes: function (header) {
        var authMethods;
        this.set('previewDetails.authMethods', []);
        if (header.primaryAccessCode == "TPWD" && (!header.secondaryAccessCode ||
            header.secondaryAccessCode == '')) {
            authMethods = [{
                'method': 'TPWD',
                'wrapperValue': ''
            }];
            this.set('previewDetails.authMethods', authMethods);
        }
        if (header.primaryAccessCode == "SOTP" && (!header.secondaryAccessCode ||
            header.secondaryAccessCode == '')) {
            authMethods = [{
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }]
            this.set('previewDetails.authMethods', authMethods);
        }
        if (header.primaryAccessCode == "TPWD" && header.secondaryAccessCode == "SOTP" || header.secondaryAccessCode ==
            "OTP") {
            authMethods = [{
                'method': 'TPWD',
                'wrapperValue': ''
            }, {
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }];
            this.set('previewDetails.authMethods', authMethods);
        }
        if (header.primaryAccessCode == "SOTP" && header.secondaryAccessCode == "TPWD") {
            authMethods = [{
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }, {
                'method': 'TPWD',
                'wrapperValue': ''
            }];
            this.set('previewDetails.authMethods', authMethods);
        }
    },

    authenticationValidation: function (autharray) {
        var authMethodLength = autharray.length;
        for (var i = 0; i < authMethodLength; i++) {
            if (autharray[i].method == "OTP" || autharray[i].method == "SOTP") {
                if (!autharray[i].wrapperValue) {
                    this.fire('oe-show-error', getLabel("m_OTPMandatory"));
                    return true;
                }
            } else if (autharray[i].method == "TPWD") {
                if (!autharray[i].wrapperValue) {
                    this.fire('oe-show-error', getLabel("m_TPWDMandatory"));
                    return true;
                }
            }
        }
    },

    /* code to fetch workflow rules
     debit account can be a string in case of single payment or array of string 
     in case of multi debit account scenario */
    financialWorkflow: function (finTxnType, txnAmount, txnCurrency, debitAccount, highestEntryAmount, isZeroAmountTransaction) {
        var self = this;
        if (!highestEntryAmount)
            highestEntryAmount = txnAmount;
        this.fire('start-processing-loader');
        var debitAccountString = "";
        var financialPrpmAjaxCall = document.createElement('oe-ajax');
        financialPrpmAjaxCall.contentType = "application/json";
        financialPrpmAjaxCall.handleAs = "json";
        financialPrpmAjaxCall.url =
            "/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=MULTIPLE_APPROVALS_SELECTION_AVAILABLE";
        financialPrpmAjaxCall.method = "get";
        financialPrpmAjaxCall.addEventListener('response', function (event) {
            self.fire('stop-processing-loader');
            var response = event.detail && event.detail.response;

            if (response[0].propertyValue === "N") {
                self.set('previewDetails.isMultipleApprovalSelection', false);
            } else {
                self.set('previewDetails.isMultipleApprovalSelection', true);
            }
            var financialWorkflowAjaxCall = document.createElement('oe-ajax');
            financialWorkflowAjaxCall.contentType = "application/json";
            financialWorkflowAjaxCall.handleAs = "json";

            // start of changes made for 273463 fix
            if (debitAccount != undefined) {
                if (debitAccount.constructor.name === 'Array') {
                    //handle array
                    _.forEach(debitAccount, function (item) {
                        debitAccountString = debitAccountString + "&filter[where][accountId]=" + item;
                    }.bind(this));
                } else {
                    debitAccountString = "&filter[where][accountId]=" + debitAccount;
                }
            }
            // end of changes made for 273463 fix
            if (isZeroAmountTransaction && isZeroAmountTransaction === 'Y') {
                financialWorkflowAjaxCall.url = "/api/corporates/" + clientStorage.get(storageType.session, 'corpId') + "/customapprovalrules" + "?filter[where][transactionAmount]=" + txnAmount + "&filter[where][transactionCurrency]=" + txnCurrency + "&filter[where][highestEntryAmount]=" + highestEntryAmount + "&filter[where][transactionType]=" + finTxnType + "&filter[where][isZeroAmountTransaction]=" + isZeroAmountTransaction;
            } else {
                financialWorkflowAjaxCall.url = "/api/corporates/" + clientStorage.get(storageType.session, 'corpId') + "/customapprovalrules" + "?filter[where][transactionAmount]=" + txnAmount + "&filter[where][transactionCurrency]=" + txnCurrency + "&filter[where][highestEntryAmount]=" + highestEntryAmount + "&filter[where][transactionType]=" + finTxnType;
            }

            if (debitAccountString && debitAccountString !== '') {
                financialWorkflowAjaxCall.url = financialWorkflowAjaxCall.url + debitAccountString;
            }

            financialWorkflowAjaxCall.method = "get";
            financialWorkflowAjaxCall.addEventListener('response', function (event) {
                self.fire('stop-processing-loader');
                var response = event.detail && event.detail.response;
                self.setRules(response);
            });
            financialWorkflowAjaxCall.addEventListener('error', function (event) {
                self.fire('stop-processing-loader');//Added by satya for error handling
                if (typeof self._errorHandler == 'function')
                    self._errorHandler(event);
                else
                    showAjaxError(event)
            });
            self.fire('start-processing-loader');
            oeAjaxEventListner(financialWorkflowAjaxCall);
            financialWorkflowAjaxCall.generateRequest();
        });
        oeAjaxEventListner(financialPrpmAjaxCall);
        financialPrpmAjaxCall.generateRequest();
    },

    setRules: function (response) {
        var self = this;
        if (response.error != undefined) {
            self.fire('oe-show-error', response.error);
        } else {
            if (response.length != 0) {
                var tempRuleList = response;
                var tempArr = tempRuleList.map(function (item) {
                    item["pendingApprovalsDesc"] = self.parseFutureRule(item.pendingApprovals, item.roleDetails);
                    return item;
                });
                self.set('previewDetails.displayWorkflow', true);
                self.set('previewDetails.rulesList', tempArr);
                //If workflow is enabled, to read response Object from OCH
                if (!response.detail && self.responseObjectWorkflow) {
                    response.detail = self.responseObjectWorkflow.detail;
                }
                _scrollIntoView();
                self._callWorkflowPage(response);
            }
        }
    },

    setRulesNonFinWithKey: function (response) {
        var self = this;
        var indexOfRoleDetails;
        if (response.error != undefined) {
            self.fire('oe-show-error', response.error);
        } else {
            if (response.length != 0) {
                var tempRuleList = [response];
                var tempArr = tempRuleList.map(function (item) {
                    for (var i = 0; item.approverDetails; i++) {
                        if (item.approverDetails[i].roleDetails != undefined) {
                            indexOfRoleDetails = i;
                            break;
                        }
                    }
                    item["pendingApprovalsDesc"] = self.parseFutureRuleNonFinWithKey(item.pendingApprovals, item.approverDetails[indexOfRoleDetails].roleDetails);
                    return item;
                });
                self.set('previewDetails.displayWorkflow', true);
                self.set('previewDetails.rulesList', tempArr);
                //If workflow is enabled, to read response Object from OCH
                if (!response.detail && self.responseObjectWorkflow) {
                    response.detail = self.responseObjectWorkflow.detail;
                }
                _scrollIntoView();
                self._callWorkflowPage(response);
            }
        }
    },

    renderApprovalStepper: function (selectedRule) {

        /*
    this.set('previewDetails.ruleId', selectedRule.ruleId);
    var self = this;

    var selectedFutureRule = _.trimEnd(selectedRule.pendingApprovals, '|');

    if (selectedRule.followHierarchy.cmCode === "Y") {
      self.set('previewDetails.followHierarchy', true);
    } else {
      self.set('previewDetails.followHierarchy', false);
    }

    var futureRuleArr = selectedFutureRule.split("|");
    var tempProgressDetails = [];

    for (var i = 0; i < futureRuleArr.length; i++) {
      tempProgressDetails.push({
        "primaryText": selectedRule.roleDetails[_.findIndex(selectedRule.roleDetails, function (o) {
          return o.roleId == futureRuleArr[i].split("^")[1];
        })].roleDescription,
        "secondaryText": '',
        "userDetails": [],
        "numofApprovers": Number.parseInt(self.previewDetails.isMultipleApprovalSelection ? futureRuleArr[i].split("^")[0] : 1),
        "approverLevel": 0,
        "approversList": [],
        "approverIds": [],
        "roleId": futureRuleArr[i].split("^")[1]
      });

      if (!self.previewDetails.isMultipleApprovalSelection) {
        break;
      }
    }

    self.set('previewDetails.progressDetails', []);
    self.set('previewDetails.progressDetails', tempProgressDetails);
    */
        //console.log("inside selectedRule" + JSON.stringify(selectedRule));

        this.set('previewDetails.ruleId', selectedRule.ruleId);

        var self = this;
        if (selectedRule && selectedRule.followHierarchy && selectedRule.followHierarchy.cmCode === "Y") {
            self.set('previewDetails.followHierarchy', true);
        } else {
            self.set('previewDetails.followHierarchy', false);
        }
        //If-else conditon added by Satya for GEN Rule case 
        if (selectedRule.pendingApprovals != undefined) {
            var selectedFutureRule = _.trimEnd(selectedRule.pendingApprovals, '|');

            var futureRuleArr = selectedFutureRule.split("|");
            var tempProgressDetails = [];
            //Added by satya for 1 apprver rule case 
            if (futureRuleArr != "") {
                for (var i = 0; i < futureRuleArr.length; i++) {
                    tempProgressDetails.push({
                        "primaryText": selectedRule.roleDetails[_.findIndex(selectedRule.roleDetails, function (o) {
                            return o.roleId == futureRuleArr[i].split("^")[1];
                        })].roleDescription,
                        "secondaryText": '',
                        "userDetails": [],
                        "numofApprovers": Number.parseInt(self.previewDetails.isMultipleApprovalSelection ? futureRuleArr[i].split("^")[0] : 1),
                        "approverLevel": 0,
                        "approversList": [],
                        "approverIds": [],
                        "roleId": futureRuleArr[i].split("^")[1]
                    });

                    if (!self.previewDetails.isMultipleApprovalSelection) {
                        break;
                    }
                }
            }

            //console.log("tempProgressDetails" + JSON.stringify(tempProgressDetails));

            self.set('previewDetails.progressDetails', []);
            self.set('previewDetails.progressDetails', tempProgressDetails);

        }
        else {
            self.set('previewDetails.progressDetails', []);
        }
    },
    nonFinancialWorkflow: function (nonFinancialType) {
        var self = this;
        this.fire('start-processing-loader');
        var nonFinPrpmAjaxCall = document.createElement('oe-ajax');
        nonFinPrpmAjaxCall.contentType = "application/json";
        nonFinPrpmAjaxCall.handleAs = "json";
        nonFinPrpmAjaxCall.url =
            "/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=MULTIPLE_APPROVALS_SELECTION_AVAILABLE";
        nonFinPrpmAjaxCall.method = "get";
        nonFinPrpmAjaxCall.addEventListener('response', function (event) {
            self.fire('stop-processing-loader');
            var response = event.detail && event.detail.response;
            if (response[0].propertyValue === "N") {
                self.set('previewDetails.isMultipleApprovalSelection', false);
            } else {
                self.set('previewDetails.isMultipleApprovalSelection', true);
            }
            var nonFinWorkflowAjaxCall = document.createElement('oe-ajax');
            nonFinWorkflowAjaxCall.contentType = "application/json";
            nonFinWorkflowAjaxCall.handleAs = "json";

            nonFinWorkflowAjaxCall.url = "/api/corporates/" + clientStorage.get(storageType.session, 'corpId') + "/customapprovalrules" +
                "?&filter[where][transactionType]=" + nonFinancialType;

            nonFinWorkflowAjaxCall.method = "get";
            nonFinWorkflowAjaxCall.addEventListener('response', function (event) {
                self.fire('stop-processing-loader');
                var response = event.detail && event.detail.response;
                self.setRules(response);
            });
            nonFinWorkflowAjaxCall.addEventListener('error', function (event) {
                self.fire('stop-processing-loader');
                showAjaxError(event);
            });
            self.fire('start-processing-loader');
            oeAjaxEventListner(nonFinWorkflowAjaxCall);
            nonFinWorkflowAjaxCall.generateRequest();
        });
        oeAjaxEventListner(nonFinPrpmAjaxCall);
        nonFinPrpmAjaxCall.generateRequest();
    },

    nonFinancialWorkflowWithKey: function (approvalKey) {
        var self = this;
        this.fire('start-processing-loader');
        var nonFinPrpmAjaxCall = document.createElement('oe-ajax');
        nonFinPrpmAjaxCall.contentType = "application/json";
        nonFinPrpmAjaxCall.handleAs = "json";
        nonFinPrpmAjaxCall.url =
            "/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=MULTIPLE_APPROVALS_SELECTION_AVAILABLE";
        nonFinPrpmAjaxCall.method = "get";
        nonFinPrpmAjaxCall.addEventListener('response', function (event) {
            self.fire('stop-processing-loader');
            var response = event.detail && event.detail.response;
            if (response[0].propertyValue === "N") {
                self.set('previewDetails.isMultipleApprovalSelection', false);
            } else {
                self.set('previewDetails.isMultipleApprovalSelection', true);
            }
            var nonFinWorkflowAjaxCall = document.createElement('oe-ajax');
            nonFinWorkflowAjaxCall.contentType = "application/json";
            nonFinWorkflowAjaxCall.handleAs = "json";

            nonFinWorkflowAjaxCall.url = "/api/corporates/" + clientStorage.get(storageType.session, 'corpId') + "/customapprovaldetails" +
                "?filter[where][approvalKey]=" + approvalKey;

            nonFinWorkflowAjaxCall.method = "get";
            nonFinWorkflowAjaxCall.addEventListener('response', function (event) {
                self.fire('stop-processing-loader');
                var response = event.detail && event.detail.response;
                self.setRulesNonFinWithKey(response);
            });
            nonFinWorkflowAjaxCall.addEventListener('error', function (event) {
                self.fire('stop-processing-loader');
                showAjaxError(event);
            });
            self.fire('start-processing-loader');
            oeAjaxEventListner(nonFinWorkflowAjaxCall);
            nonFinWorkflowAjaxCall.generateRequest();
        });
        oeAjaxEventListner(nonFinPrpmAjaxCall);
        nonFinPrpmAjaxCall.generateRequest();
    },



    submitNonFinancialDetails: function (url, method, body, headervalue, transactionType, channelContextVal, approvalKey, encryptedData) {
        var self = this;
        this.fire('start-processing-loader');
        let ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = url;
        ajaxCall.method = method;
        ajaxCall.body = body;
        // fix for 312552, 312790, 312793,312789 issues
        var confirmationCode = "";

        if (self.cmCode && (self.cmCode === "MPA" || self.cmCode === "CVA" || self.cmCode === "OVA" || self.cmCode === "MVA" || self.cmCode === "RVA" || self.cmCode === "VHA" || self.cmCode === "DVH" || self.cmCode === "MVH")) {
            confirmationCode = "N";
        }

        if (channelContextVal === undefined) {
            if (ajaxCall.header == undefined || Object.keys(ajaxCall.header).length == 0) {
                ajaxCall.headers["authorizationDetails"] = JSON.stringify({
                    primaryAccessCode: headervalue.primaryAccessCode ? headervalue.primaryAccessCode : "",
                    secondaryAccessCode: headervalue.secondaryAccessCode ? headervalue.secondaryAccessCode : "",
                    userId: clientStorage.get(storageType.session, 'userId'),
                    acceptTermsAndConditions: headervalue.acceptTermsAndConditions ? headervalue.acceptTermsAndConditions : "",
                    // fix for 312552, 312790, 312793,312789 issues
                    isConfirmationMode: this.previewDetails.isConfirmationMode ? this.previewDetails.isConfirmationMode : confirmationCode,
                    customParameters: {
                        ochTransactionId: headervalue.ochTransactionId ? headervalue.ochTransactionId : "",
                        authorizationMode: headervalue.authorizationMode ? headervalue.authorizationMode : ""
                    }
                });
            }

            if (headervalue.workflowInput) {
                var finalHeaders = JSON.parse(ajaxCall.headers["authorizationDetails"]);
                finalHeaders.workflowInput = headervalue.workflowInput ? headervalue.workflowInput : ""
                ajaxCall.headers["authorizationDetails"] = JSON.stringify(finalHeaders);
            }
        } else {
            ajaxCall.headers["authorizationDetails"] = "";
        }

        if (encryptedData !== undefined) {
            ajaxCall.headers["encrypteddata"] = sbEncrypt.encrypt(JSON.stringify(encryptedData));
        }

        ajaxCall.addEventListener('response', function (event) {
            self.fire('stop-processing-loader');
            self.loaderActive = false;
            //Status Code 204 has been added for delete functionality
            if (event.detail.__data.status === 200 || event.detail.__data.status === 204) {
                self.previewDetails.successMessage = event.detail.__data.status;
                if (typeof self._callSucessPage == 'function')
                    _scrollIntoView();
                self._callSucessPage(event);
            }
        });
        ajaxCall.addEventListener('error', function (event) {
            self.fire('stop-processing-loader');
            self.loaderActive = false;
            if (event.detail.request.__data.status === 401) {
                var responseHeader = JSON.parse(event.detail.request.xhr.getResponseHeader(
                    'channelcontext'));
                //Need to check if workflow is enabled or not hence this variable is set
                self.channelContext = responseHeader;
                self.channelObject = self.channelContext;
                if (responseHeader.authorization != undefined) {
                    this.header = {
                        "primaryAccessCode": responseHeader.authorization.firstAuthorizationMode,
                        "secondaryAccessCode": responseHeader.authorization.secondAuthorizationMode
                    }
                    self.headerObject = this.header;
                    if (responseHeader.authorization.firstAuthorizationMode || responseHeader.authorization.secondAuthorizationMode)
                        self.setAuthorizationModes(this.header);
                    // fix for 312552, 312790, 312793,312789 issues
                    if (responseHeader.authorization.isConfirmationMode) self.set('previewDetails.isConfirmationMode', responseHeader.authorization.isConfirmationMode);
                    if (responseHeader.authorization.workFlowRequired === 'Y') {
                        self.set('previewDetails.displayComments', false);
                        self.set('previewDetails.approverComment', "");
                        if (approvalKey != undefined) {
                            //done changes for non financial with approval key
                            self.nonFinancialWorkflowWithKey(approvalKey);
                        } else if (transactionType != undefined) {
                            self.nonFinancialWorkflow(transactionType);
                        } else {
                            event.channelContext = self.channelObject;
                            _scrollIntoView();
                            self._callWorkflowPage(event);
                        }
                        self.responseObjectWorkflow = event;
                        if (responseHeader.authorization.firstAuthorizationMode)
                            self.set('previewDetails.displayAuthorization', true);
                    } else {
                        if (responseHeader.authorization.workFlowRequired === 'N') {
                            self.set('previewDetails.displayWorkflow', false);
                            self.set('previewDetails.displayComments', true);
                            self.set('previewDetails.approverComment', "");
                        }
                        if (responseHeader.authorization.firstAuthorizationMode || responseHeader.authorization.secondAuthorizationMode)
                            self.set('previewDetails.displayAuthorization', true);
                        event.channelContext = self.channelObject;
                        _scrollIntoView();
                        self._callWorkflowPage(event);
                    }

                } else {
                    var tempHeader = JSON.parse(event.detail.request.xhr.getResponseHeader('channelcontext'));
                    if (typeof self._errorHandler == 'function')
                        self._errorHandler(event);
                    else
                        self.fire('oe-show-error', tempHeader.status.message[0].messageDesc);
                }
            } else {
                //Headers is obtained as a single string and JSON.stringify will stringify the whole string hence broken down
                self.authSuccess = false;
                var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
                var headers = convertedArr.reduce(function (each, current) {
                    var parts = [current.split(": ", 1).toString(), current.split(": ").slice(
                        1).join(": ")];
                    each[parts[0]] = parts[1];
                    return each;
                }, {});
                if (headers.channelcontext) {
                    if (self._errorHandler != undefined) {
                        if (typeof self._errorHandler == 'function') {
                            self._errorHandler(event);
                        }
                    } else if (typeof showAjaxError == 'function') {
                        showAjaxError(event);
                    } else {
                        self.fire('oe-show-error', JSON.parse(headers.channelcontext).status.message[0].messageDesc);
                    }
                }
                else self.fire('oe-show-error', event.detail.error.message);
            }
        });
        oeAjaxEventListner(ajaxCall);
        if (!headervalue || headervalue && _.isEmpty(headervalue.ochTransactionId)) {
            ajaxCall.generateRequest();
        }
        else if (headervalue && headervalue.ochTransactionId) {
            if (_.isEmpty(self.ochTxnIdSuccess)) {
                self.ochTxnIdSuccess = headervalue.ochTransactionId;
                ajaxCall.generateRequest();
            }
            else if (headervalue.ochTransactionId !== self.ochTxnIdSuccess) {
                self.ochTxnIdSuccess = headervalue.ochTransactionId;
                ajaxCall.generateRequest();
            }
            else {
                self.fire('stop-processing-loader');
            }
        }

    },

    parseFutureRule: function (futureRule, roleDetailsArr) {
        var transformedString = "";
        if (futureRule != undefined) {
            futureRule = _.trimEnd(futureRule, '|');
            var futureRuleArr = futureRule.split("|");
            for (var i = 0; i < futureRuleArr.length; i++) {
                let eachRule = futureRuleArr[i].split("^");
                var desc = roleDetailsArr[_.findIndex(roleDetailsArr, function (o) { return o.roleId == eachRule[1] })].roleDescription;
                transformedString = transformedString + eachRule[0] + " " + desc + " + ";

            }
            return _.trimEnd(transformedString, ' + ');
        }
        //Else conditon added by Satya for 1 Gen case with no further approval
        else {
            return roleDetailsArr[0].roleDescription;
        }

    },

    parseFutureRuleNonFinWithKey: function (futureRule, roleDetailsArr) {
        var transformedString = "";
        futureRule = _.trimEnd(futureRule, '|');
        var futureRuleArr = futureRule.split("|");
        for (var i = 0; i < futureRuleArr.length; i++) {
            let eachRule = futureRuleArr[i].split("^");
            var desc = roleDetailsArr != undefined ? roleDetailsArr.roleDescription : "";
            transformedString = transformedString + eachRule[0] + " " + desc + " + ";
        }
        return _.trimEnd(transformedString, ' + ');
    },

    getRoleName: function (approveRoleId, response) {
        for (var index = 0; index < response.role.length; index++) {
            if (response.role[index].roleId === approveRoleId) {
                return response.role[index].roleDescription;
            }
        }
    },

    groupbyRoleID: function (userDetails) {

        var groupBy = function (xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };
        return groupBy(userDetails, 'roleId')
    },

    matchRoleCount: function (roleDescription, ruleDefinition) {

        var ruleArray = ruleDefinition.split(" + ");
        for (var i = 0; i < ruleArray.length; i++) {

            if (ruleArray[i].indexOf(roleDescription) !== -1) {
                return parseInt(ruleArray[i].split(" ")[0]);
            }
        }
    },

    checkandAddRoleIfAny: function () {
        var count = [];
        this.approversTemp = [];
        for (var i = 0; i < this.approversPost.length; i++) {
            this.approversTemp.push(this.approversPost[i]);
        }
        for (var index = 0; index < this.progressDetails.length; index++) {

            count[index] = this.approversTemp.filter(function (v) {
                return v.approverLevel == index
            }).length;

            if (count[index] < this.progressDetails[index].numofApprovers) {
                for (var fillIndex = count[index]; fillIndex < this.progressDetails[index].numofApprovers; fillIndex++)
                    this.push('approversTemp', {
                        'approverLevel': index,
                        'userName': ''
                    });
            }
        }

        this.approversTemp.sort(function (a, b) {
            return a.approverLevel - b.approverLevel;
        });
    },

    indexOfRole: function (roleDescription, ruleDefinition) {
        var ruleArray = ruleDefinition.split(" + ");
        for (var i = 0; i < ruleArray.length; i++) {

            if (ruleArray[i].indexOf(roleDescription) !== -1) {
                return i;
            }
        }
    }
}
